import { ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { AppButtonComponent } from '@hunting-nature/shared-ui/components/app-button/app-button.component';
import { ProgressIndicatorComponent } from '@hunting-nature/shared-ui/components/progress-indicator/progress-indicator.component';
import { pickIcons } from '@hunting-nature/shared-ui/helper/icon-registry.const';
import { IonIcon, IonModal } from '@ionic/angular/standalone';
import { TranslocoPipe } from '@jsverse/transloco';
import { addIcons } from 'ionicons';
import { Store } from '@ngrx/store';

import { WhatsNewStepComponent } from './components/whats-new-step/whats-new-step.component';
import { WhatsNewActions } from './redux/whats-new.actions';
import { WhatsNewSelectors } from './redux/whats-new.reducer';
import { WHATS_NEW_FLOW_CONFIG, WHATS_NEW_STEPS } from './shared/whats-new.config';

@Component({
  selector: 'app-whats-new',
  imports: [IonModal, IonIcon, AppButtonComponent, ProgressIndicatorComponent, WhatsNewStepComponent, TranslocoPipe],
  templateUrl: './whats-new.component.html',
  styleUrl: './whats-new.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // ion-modal portals its content outside this component's DOM subtree, so encapsulated
  // styles can't reach it. Styles are scoped manually under .whats-new-modal / .whats-new instead.
  encapsulation: ViewEncapsulation.None,
})
export class WhatsNewComponent {
  // services
  private readonly store = inject(Store);

  // config
  protected readonly flowConfig = WHATS_NEW_FLOW_CONFIG;

  // UI bindings
  protected readonly isOpen$$ = this.store.selectSignal(WhatsNewSelectors.isWhatsNewOpen);
  protected readonly currentStep$$ = this.store.selectSignal(WhatsNewSelectors.currentWhatsNewStep);
  protected readonly isFirstStep$$ = this.store.selectSignal(WhatsNewSelectors.isFirstWhatsNewStep);
  protected readonly isLastStep$$ = this.store.selectSignal(WhatsNewSelectors.isLastWhatsNewStep);

  protected readonly currentStepConfig$$ = computed(() => WHATS_NEW_STEPS[this.currentStep$$() - 1]);

  constructor() {
    addIcons({ ...pickIcons('close') });
  }

  // handlers
  handleClose(): void {
    if (!this.isOpen$$()) return;
    this.store.dispatch(WhatsNewActions.dismissWhatsNew());
  }

  handleBack(): void {
    if (this.isFirstStep$$()) return;
    this.store.dispatch(WhatsNewActions.previousWhatsNewStep());
  }

  handleNext(): void {
    if (this.isLastStep$$()) {
      this.handleClose();
      return;
    }
    this.store.dispatch(WhatsNewActions.nextWhatsNewStep());
  }
}
